"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEmailPreviewDimStyle = void 0;
const buildEmailPreviewDimStyle = () => `<style>
  tr[data-section]:not([data-section="note"]) { opacity: 0.5; }
  tr[data-section]:not([data-section="note"]) a { pointer-events: none; }
</style>`;
exports.buildEmailPreviewDimStyle = buildEmailPreviewDimStyle;
